import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { SubjectService } from 'src/app/services/subject.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {
  ERROR = "Your account couldn't be verified. Please try again using other number.";
  reserve: boolean;
  data: any
  errorCode: string
  constructor(
    private modalController: ModalController,
    private SS: SubjectService,
    private translate: TranslateService,
    private route: Router
  ) {
    this.SS.addonBuyError.subscribe((r: any) => {
      if (r) {
        this.reserve = false;
        this.ERROR = r;
        if (
          this.ERROR == 'null' ||
          this.ERROR == null ||
          this.ERROR == 'ERROR_RTF_VAL-00005' ||
          this.ERROR == 'ERROR_RTF_VAL-00007'||
          this.ERROR == 'ERROR_RTF_COMS-00001'
        ) {
          this.translate.get(['SORRY_ERROR']).subscribe((m) => {
            this.ERROR = m['SORRY_ERROR'];
          });
        }
        // if(this.ERROR ==  this.translate.instant('ERROR_VAL_00011')){
        //   this.reserve = true;
        // }
      }
    });
  }

  ngOnInit() {
    if(this.data && this.data.errorCode) {
      this.errorCode = this.data.errorCode.trim()
    } 
    if(this.data && this.data.error && this.data.errorCode){
      this.ERROR = this.data.error
    }
  }

  ok() {
    this.dismiss();
  }

  cancel() {
    this.dismiss();
  }

  closePopUpEN() {
    this.dismiss();
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  goHome(){
    localStorage.clear();
    this.dismiss();
    this.route.navigateByUrl('/home')
  }

  tryAgain(){
    window.location.reload();
  }
}
